import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import MapComponent from './components/map/baseMap';
import LoginComponent from './components/login/loginComponent';
import ProtectedRoute from './components/protectedRouteComponent';
import "./leaflet.css";

function App() {
  useEffect(() => {
    document.title = 'Lira';
    
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = '/lira_logo.png';
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<LoginComponent />} />
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <MapComponent />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </div>
  );
}

export default App;
